// src/pages/CourseTime/components/slides/common/SlideTitleSpoken.comp.jsx
import React from 'react';

// Some slides only carry their heading as origin.headline/title/section_title
// rather than SlideTitle - fall back through those before giving up on a title.
export const resolveSlideTitle = (slide) => {
  const origin = slide._pbdq_origin || slide;
  return slide.SlideTitle || origin.headline || origin.title || origin.section_title
    || origin.scene_title || origin.bridge_title || origin.reveal_title || '';
};

// The `skipTitleSpeech ? title : renderSpokenText('title', title)` ternary that
// every slide layout repeats for its title. Renders nothing extra around it.
const SlideTitleSpoken = ({ slide, skipTitleSpeech, renderSpokenText }) => {
  const title = resolveSlideTitle(slide);
  return <>{skipTitleSpeech ? title : renderSpokenText('title', title)}</>;
};

export default SlideTitleSpoken;
